import { StepPageWrapper } from '@Layout/StepPageWrapper.tsx';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useOwnersCenterLogic } from './hooks/useOwnersCenterLogic';
import { OwnersCenterForm } from './OwnersCenterForm/OwnersCenterForm';
import { UboResponse } from '@Store/index';

interface OwnersCenterProps {
  businessOwners: UboResponse[];
  refetchBusinessOwners: () => void;
}

export const OwnersCenter = (props: OwnersCenterProps) => {
  const { businessOwners, refetchBusinessOwners } = props;
  const { t } = useTranslation();

  const { handleSubmit, formMethods, isUpdatePrimaryOwnerPercentage, onEditClick, onAddClick } =
    useOwnersCenterLogic(businessOwners);

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isUpdatePrimaryOwnerPercentage}
        handleSubmit={formMethods.handleSubmit(handleSubmit)}
        heading={t('pages.ownersCenter.title')}
        customSubmitTitle={t('pages.ownersCenter.cta')}
        content={t('pages.ownersCenter.content')}
        formMethods={formMethods}>
        <OwnersCenterForm
          formMethods={formMethods}
          uboList={businessOwners}
          onEditClick={onEditClick}
          onAddClick={onAddClick}
          refetchBusinessOwners={refetchBusinessOwners}
        />
      </StepPageWrapper>
    </FormProvider>
  );
};
